/**
 * DNB Eufemia Defaults
 *
 */

export const LOCALE = 'nb-NO'
export const CURRENCY = 'NOK'
export const CURRENCY_DISPLAY = 'code' // code, name, symbol, narrowSymbol
export const COUNTRY = 'NO' // ISO 3166-1 alpha-2
